// strings/install.ts (full screen, 2026-10-15) — playing full screen: the title's tip and the settings entry (client ui/install.tsx).
// An iPhone goes full screen only as a home-screen app (Share, then Add to Home Screen); Android and desktop Chrome offer an install
// prompt; any other browser may have Install app or Add to Home Screen in its menu.
import type { StringBank } from '../schema/strings';

export default {
  title: 'Play full screen',
  iosSteps: 'Tap Share, then Add to Home Screen.',
  why: 'From your home screen it opens full screen, with no browser bars.',
  promptBody: 'Install {app} to play with no browser bars.',
  install: 'Install',
  installApp: 'Install app',
  dismiss: 'Hide this tip',
  installed: 'You’re playing the installed app, full screen.',
  menu: 'Open your browser’s menu and choose Install app or Add to Home Screen.',
} as const satisfies StringBank;
